<template>
  <div id="app">
    <home></home>
  </div>
</template>

<script>


export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
@import './scss/style';

body{
    margin:0; 
    background: #f0f6f7;
    overflow-x: hidden;
  }
#app {
  font-family: 'kufi-regular','bukra-regular';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  line-height: 1.6;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}


a {
  color: #3a80fe;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue